import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation } from '@tanstack/react-query'
import { FlatDetail } from 'types/api'

/**
 * Upload a single gallery image to a flat.
 *
 * Intentionally uploads ONE file per request so the caller can run uploads
 * sequentially (await each) — parallel multi-file PATCHes race on the server
 * and drop/disorder images in production. No per-call success toast or cache
 * invalidation; the caller drives progress and invalidates once at the end.
 */
export function useUploadFlatImage() {
  const onError = useOnError()

  async function uploadImage({ id, file }: { id: string; file: File }) {
    const formData = new FormData()
    formData.append('gallery', file)

    const res = await apiClient.patch<FlatDetail>(
      `${SNA_PREFIX}flats/${id}`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    )
    return res.data
  }

  return useMutation({ mutationFn: uploadImage, onError })
}
